import type { z } from 'zod';

export type ZodDto<TSchema extends z.ZodType = z.ZodType> = {
  new (): z.output<TSchema>;
  isZodDto: true;
  schema: TSchema;
  create(input: unknown): z.output<TSchema>;
};

export function createZodDto<TSchema extends z.ZodType>(schema: TSchema) {
  // biome-ignore lint/complexity/noStaticOnlyClass: needed for zod class
  class AugmentedZodDto {
    public static isZodDto = true;
    public static schema = schema;

    public static create(input: unknown) {
      // biome-ignore lint/complexity/noThisInStatic: needed for zod class
      return this.schema.parse(input);
    }
  }

  return AugmentedZodDto as unknown as ZodDto<TSchema>;
}

// biome-ignore lint/suspicious/noExplicitAny: needed for zod class
export function isZodDto(metatype: any): metatype is ZodDto {
  return metatype?.isZodDto;
}
